module.exports = __webpack_public_path__ + "static/tech-check-eaed38775a34ab6dc2d45595555514c6.png";